import { NgModule } from "@angular/core";
import { GuestLayoutComponent } from "./guest-layout.component";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [GuestLayoutComponent],
  imports: [CommonModule, RouterModule],
})
export class GuestLayoutModule {}
